import { c as _c } from "react/compiler-runtime";
import React from "react";
import style from "./DonationsTotal.module.scss";
import { thousandize } from "../../../../util/formatting";
const DonationsTotals: React.FC<{
  sum: number;
  period: string;
  comparison?: string;
}> = t0 => {
  const $ = _c(12);
  const {
    sum,
    period,
    comparison
  } = t0;
  let t1;
  if ($[0] !== period) {
    t1 = <span className={style.period}>{period}</span>;
    $[0] = period;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== sum) {
    t2 = thousandize(sum);
    $[2] = sum;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <h2>{t2} kr</h2>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== comparison) {
    t4 = comparison && <h4>{comparison}</h4>;
    $[6] = comparison;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className={style.totals} data-cy="aggregated-donation-totals">{t1}{t3}{t4}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default DonationsTotals;